import { WHITE, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getOfferCardWidgetStyles = props => {
  var imageUrl = props.imageUrl,
    _props$parentType = props.parentType,
    parentType = _props$parentType === void 0 ? 'GRADIENT' : _props$parentType;
  return StyleSheet.create({
    container: Object.assign({
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center'
    }, parentType === 'GRADIENT' && {
      borderWidth: 1,
      borderRadius: tokens.spacing.SPACING_16,
      borderColor: WHITE
    }),
    imageContainer: {
      alignSelf: 'center'
    },
    leftContainer: {
      flexDirection: 'row'
    },
    leftImage: {
      alignSelf: 'center',
      padding: tokens.spacing.SPACING_12
    },
    rightContainer: Object.assign({
      padding: tokens.spacing.SPACING_12,
      paddingLeft: tokens.spacing.SPACING_11,
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
      flex: 1
    }, !imageUrl && {
      borderLeftWidth: 1,
      borderLeftColor: WHITE
    }),
    rightIcon: {
      marginLeft: tokens.spacing.SPACING_16,
      flexShrink: 0
    },
    subHeading: {
      marginTop: tokens.spacing.SPACING_2
    },
    button: {
      marginTop: tokens.spacing.SPACING_4
    },
    rightCounter: {
      padding: tokens.spacing.SPACING_12,
      flexShrink: 0
    }
  });
};